<template>
  <div id="common-date-picker">
    <div id="label" v-if="label !== ''">
      <label class="title" for="date-picker">{{label}}</label>
    </div>
    <div id="date-picker">
      <date-picker
        class="date"
        ref="requestStartDate"
        :defaultDate="$moment(date.startDate).toDate()"
        @input="value => startInput(value)"
      />
      ~
      <date-picker
        class="date"
        ref="requestEndDate"
        :defaultDate="$moment(date.endDate).toDate()"
        @input="value => endInput(value)"
      />
      <b-form-group class='current-date'>
        <b-form-radio-group
          ref="current-date"
          v-model="selectRadioDate"
          :options="currentDateOptions"
          buttons
          size="sm"
          @change="selRequestDate"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </div>
</template>

<script>
/*
  ※주의 : 데이터 추가할때 주석부분에도 추가해주세요.※
  =================================================
  ※ prop data ※
  [label : String]
  [currentOptions : Array] => text(화면에 보여지는 값), value(data의 value 값) , default : 오늘날짜, 데이터 보낼때 format(YYYYMMDD) 로 보내야됨.
  =================================================
  ※ Event ※
  input - 날짜 변경 시 이벤트 발생.
  =================================================
*/
import datePicker from '@/components/common/datepicker/Picker'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    currentValue: {
      type: Object,
      default: function () {
        return {
          startDate: this.$moment(new Date()).format('YYYYMMDD'),
          endDate: this.$moment(new Date()).format('YYYYMMDD')
        }
      }
    },
    currentOptions: {
      type: Array,
      default: function () {
        return [{
          text: '오늘',
          value: {
            startDate: this.$moment(new Date()).format('YYYYMMDD'),
            endDate: this.$moment(new Date()).format('YYYYMMDD')
          }
        }, {
          text: '이번달',
          value: {
            startDate: this.$moment(new Date()).format('YYYYMM01'),
            endDate: this.$moment(new Date()).endOf('month').format('YYYYMMDD')
          }
        }]
      }
    }
  },
  components: {
    datePicker
  },
  data () {
    return {
      date: {
        startDate: this.$moment(new Date()).format('YYYYMMDD'),
        endDate: this.$moment(new Date()).format('YYYYMMDD')
      },
      selectRadioDate: {
        startDate: this.$moment(new Date()).format('YYYYMMDD'),
        endDate: this.$moment(new Date()).format('YYYYMMDD')
      },
      currentDateOptions: this.currentOptions
    }
  },
  methods: {
    selRequestDate (value) {
      if (!value) return
      this.$refs.requestStartDate.$data.currentDate = this.$moment(value.startDate).toDate()
      this.$refs.requestEndDate.$data.currentDate = this.$moment(value.endDate).toDate()
      this.date = value
      this.input()
    },
    startInput (value) {
      if (!value) return
      this.date.startDate = value
      this.selectRadioDate.startDate = value
      this.currentDateOptions = this.currentOptions
      this.input()
    },
    endInput (value) {
      if (!value) return
      this.date.endDate = value
      this.selectRadioDate.endDate = value
      this.currentDateOptions = this.currentOptions
      this.input()
    },
    input () {
      this.$emit('input', this.date)
    },
  },
  watch: {
    currentValue: {
      deep: true,
      handler (date) {
        if (!date.value) return
        this.$refs.requestStartDate.$data.currentDate = this.$moment(date.value.startDate).toDate()
        this.$refs.requestEndDate.$data.currentDate = this.$moment(date.value.endDate).toDate()
        this.date = {
          startDate: this.$moment(date.value.startDate).format('YYYYMMDD'),
          endDate: this.$moment(date.value.endDate).format('YYYYMMDD')
        }
        this.selectRadioDate.startDate = date.value.startDate
        this.selectRadioDate.endDate = date.value.endDate
        this.currentDateOptions = this.currentOptions
        this.input()
      }
    }
  }
}
</script>

<style scoped>
/* 날짜 layout css */
.title {
  color: #000000;
}

#date-picker {
  float: left;
}

#date-picker .date {
  display: inline-flex;
  height: 100%;
  min-width: 50px;
  width: 115px;
  font-size: 12px;
  vertical-align: middle;
}

/* 날짜 state css */
#date-picker .current-date {
  display: inline-flex;
  margin-left: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
  vertical-align: middle;
}

#date-picker .current-date >>> label {
  margin: 0 3.5px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  box-sizing: border-box;
  color: #222222;
  font-size: 12px;
  height: 32px;
  padding-top: 6px;
}

#date-picker .current-date >>> label:hover {
  margin: 0 3.5px;
  background: #FFFFFF;
  border: 1px solid #18A0FB;
  border-radius: 4px;
  box-sizing: border-box;
  color: #18A0FB;
  font-size: 12px;
  height: 32px;
}

#date-picker .current-date >>> label.active {
  margin: 0 3.5px;
  background: #18A0FB;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 12px;
  height: 32px;
}

#date-picker .current-date >>> label.active:hover {
  margin: 0 3.5px;
  border: 1px solid #6FC5FF;
  background: #6FC5FF;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 12px;
  height: 32px;
}

#date-picker .current-date >>> label.focus {
  box-shadow: none !important;
}

/* 날짜 input css */
#date-picker >>> .input-class {
  border: 1px solid #E5E5E5 !important;
  text-align: left;
  padding: 0 10px;
  background-origin: content-box;
  background-image: url('./image/icon_calendar_n.png');
  background-position: right;
  background-repeat: no-repeat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;;
}

#date-picker >>> .input-class:hover {
  border: 1px solid #18A0FB !important;
  text-align: left;
  padding: 0 10px;
  background-origin: content-box;
  background-image: url('./image/icon_calendar_h.png');
  background-position: right;
  background-repeat: no-repeat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: #18A0FB;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;;
}

#date-picker >>> .input-class:focus {
  outline: none;
}

#date-picker >>> .input-class:hover {
  cursor: pointer;
}
</style>
